import builder from '../builder';
import StairsDescend from '../../streamline-icons/bold/stairs-descend.svg';

export default builder('IconStairsDescendBold', StairsDescend);
